@file:OptIn(InternalResourceApi::class)

package org.hyperether.auth.library.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/org.hyperether.auth.library.generated.resources/"

internal val Res.drawable.apple_icon_black: DrawableResource by lazy {
      DrawableResource("drawable:apple_icon_black", setOf(
        ResourceItem(setOf(), "${MD}drawable/apple_icon_black.xml", -1, -1),
      ))
    }

internal val Res.drawable.apple_icon_white: DrawableResource by lazy {
      DrawableResource("drawable:apple_icon_white", setOf(
        ResourceItem(setOf(), "${MD}drawable/apple_icon_white.xml", -1, -1),
      ))
    }

internal val Res.drawable.google_icon: DrawableResource by lazy {
      DrawableResource("drawable:google_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/google_icon.xml", -1, -1),
      ))
    }

internal val Res.drawable.microsoft_icon: DrawableResource by lazy {
      DrawableResource("drawable:microsoft_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/microsoft_icon.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("apple_icon_black", Res.drawable.apple_icon_black)
  map.put("apple_icon_white", Res.drawable.apple_icon_white)
  map.put("google_icon", Res.drawable.google_icon)
  map.put("microsoft_icon", Res.drawable.microsoft_icon)
}
